import { styled } from "@material-ui/core";
import { useEffect } from "react";

const Wrapper = styled("div")({
  display: "flex",
  width: "100vw",
  position: "fixed",
  bottom: 0,
});

const Scroll = styled("div")({
  height: 12,
  overflow: "scroll hidden",
});

const ColumnsCustomScroll = ({
  scrollTop,
  width,
  leftColumnWidth,
  rightColumnWidth,
}) => {
  useEffect(() => {
    // Atualiza as posições dos scroll horizontal ao mudar o scroll vertical
    const scrollLeft = document.querySelector(
      ".MuiVirtualizedTable-scroll-left"
    );
    if (scrollLeft) handleScroll("left")({ target: scrollLeft });

    const scrollRight = document.querySelector(
      ".MuiVirtualizedTable-scroll-right"
    );
    if (scrollLeft) handleScroll("right")({ target: scrollRight });
  }, [scrollTop]);

  const handleScroll = (column) => (ev: any) => {
    const scrollLeft = ev.target.scrollLeft || 0;
    const header: any = document.querySelector(
      `.MuiVirtualizedTable-header-${column}`
    );
    const elements = document.querySelectorAll(
      `.MuiVirtualizedTable-column-${column}`
    );

    if (header) header.scrollLeft = scrollLeft;

    elements.forEach((el) => {
      el.scrollLeft = scrollLeft;
    });
  };

  return (
    <Wrapper>
      <Scroll
        className="MuiVirtualizedTable-scroll-left"
        style={{ width }}
        onScroll={handleScroll("left")}
      >
        <div style={{ width: leftColumnWidth }}>.</div>
      </Scroll>
      <Scroll
        className="MuiVirtualizedTable-scroll-right"
        style={{ width }}
        onScroll={handleScroll("right")}
      >
        <div style={{ width: rightColumnWidth }}>.</div>
      </Scroll>
    </Wrapper>
  );
};

export default ColumnsCustomScroll;
